import { TechemTheme } from '@techem/techem-theme';
import { Accordion, Panel } from 'baseui/accordion';
import { TriangleDown } from 'baseui/icon';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { minBreakpoints } from '../../../../theme/mediaQueries';
import { useMediaQuery } from '../../../../../tools/hooks/useMediaQuery';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';

const InfoBoxDescription = () => {
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const isMdOrAbove = useMediaQuery(`(min-width: ${minBreakpoints.md}px)`);

  return (
    <Row className="justify-content-center">
      <Col xs={10} className="ps-0 pe-0 mt-2 mb-3 pb-4 px-0">
        <Accordion
          onChange={(val) => {
            TrackerUtil.trackLinkClick('billing-period_link-expand-info', 'link-expand-info');
            setMoreInfoOpen(!moreInfoOpen);
          }}
          overrides={{
            PanelContainer: {
              style: {
                borderBottomWidth: 0
              }
            },
            Header: {
              style: {
                backgroundColor: 'transparent',
                borderBottomWidth: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 0
              }
            },
            Content: {
              style: {
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                transitionProperty: 'all',
                transitionDuration: '300ms',
                transitionTimingFunction: 'linear',
                backgroundColor: 'transparent'
              }
            },
            ToggleIcon: {
              style: {
                display: 'none'
              }
            }
          }}
        >
          <Panel
            title={
              <div
                className="p-relative w-100 pt-3 text-center bg-transparent"
                style={{
                  transitionProperty: 'all',
                  transitionDuration: '300ms',
                  transitionTimingFunction: 'linear'
                }}
              >
                <span className={`copy${isMdOrAbove ? '' : '-s'}`}>
                  <Trans i18nKey="pageBillingPeriodDescription" />{' '}
                  <span className="d-inline-flex" style={{ color: TechemTheme.colors.primary }}>
                    <Trans
                      i18nKey={
                        moreInfoOpen
                          ? 'pageBillingPeriodDescriptionExtendedInlineButtonTextOpen'
                          : 'pageBillingPeriodDescriptionExtendedInlineButtonTextClosed'
                      }
                    />
                    <span
                      className="d-inline-flex my-auto"
                      style={{
                        transform: moreInfoOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
                        transition: 'transform 300ms ease-in-out',
                        color: TechemTheme.colors.primary
                      }}
                    >
                      <TriangleDown
                        overrides={{
                          Svg: {
                            style: {
                              marginBottom: 0,
                              marginTop: 'auto'
                            }
                          }
                        }}
                      />
                    </span>
                  </span>
                </span>
              </div>
            }
          >
            {Array.from({ length: 2 }, (_, i) => i + 1).map((index) => (
              <div key={index} className={`copy${isMdOrAbove ? '' : '-s'}`}>
                <Row>
                  <Col className="text-bold mt-3 mt-md-4 pt-2 pt-md-0">
                    <Trans i18nKey={`pageBillingPeriodDescriptionExtendedTitle${index}`} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Trans i18nKey={`pageBillingPeriodDescriptionExtendedContent${index}`} />
                  </Col>
                </Row>
              </div>
            ))}
          </Panel>
        </Accordion>
      </Col>
    </Row>
  );
};

export default InfoBoxDescription;
